// Response for /api/poweredbyshy/domains-and-tenants
const domainsAndTenants = {
    domains: {
        "pbs-mu.damdigital.com": "MUTD",
        "faithaviation-mu.damdigital.com": "FTAV",
        "glistian-mu.damdigital.com": "GLST",
        "globalelite-mu.damdigital.com": "GBET",
        "hctconcierge-mu.damdigital.com": "HCT",
        "dev.firstluxegroup-privatejet.com": "FRLG",
        "barres-mu.damdigital.com": "BGAS",
        "hummingbird-mu.damdigital.com": "HMBD",
        "mosaic-mu.damdigital.com": "MOSC",
        "wingedboots-mu.damdigital.com": "WGBT",
        "quintessentially-mu.damdigital.com": "QINT",
        "drinkathomeibiza-mu.damdigital.com": "DAHI",
        "benarrivati-mu.damdigital.com": "BNRJ",
        "test.com": "TEST",
        "pelorus-mu.damdigital.com": "PLRS",
        "jumeirahjourneys-mu.damdigital.com": "JMJR",
        "supremejet-mu.damdigital.com": "SPJT",
        "senategrandprix-mu.damdigital.com": "SNGP",
        "savilerowtravel-mu.damdigital.com": "SVRW",
        "totalmanagement-mu.damdigital.com": "TTMT",
        "fawc-mu.damdigital.com": "FAWC",
        "augustblueagency-mu.damdigital.com": "AGBA",
        "elvit-mu.damdigital.com": "ELVT",
        "evolvetalentmanagement-mu.damdigital.com": "EVLV",
        "eccelentiatravel-mu.damdigital.com": "ECLN",
        "obprivate-mu.damdigital.com": "OBTR",
        "sarahyoung-mu.damdigital.com": "SYCG",
        "elitevillas-mu.damdigital.com": "ELVL",
        "flaginthesand-mu.damdigital.com": "FITS",
        "lemmetravel-mu.damdigital.com": "LMME",
        "pinkpantherproductions-mu.damdigital.com": "PINK",
        "limelight-mu.damdigital.com": "LMLT",
        "r3-mu.damdigital.com": "R3",
        "goprivilege-mu.damdigital.com": "GOPR",
        "lanista-mu.damdigital.com": "LNST",
        "kraftyentertainment-mu.damdigital.com": "KRFT",
        "swordstravel-mu.damdigital.com": "SWTR",
        "bcdtravel-privatejet.com": "BCD",
        "shydemo-mu.damdigital.com": "SHYD",
    },
    tenantIds: {
        mutd: "MUTD",
        ftav: "FTAV",
        glst: "GLST",
        gbet: "GBET",
        hct: "HCT",
        frlg: "FRLG",
        bgas: "BGAS",
        hmbd: "HMBD",
        mosc: "MOSC",
        wgbt: "WGBT",
        qint: "QINT",
        dahi: "DAHI",
        bnrj: "BNRJ",
        test: "TEST",
        plrs: "PLRS",
        jmjr: "JMJR",
        spjt: "SPJT",
        sngp: "SNGP",
        svrw: "SVRW",
        ttmt: "TTMT",
        fawc: "FAWC",
        agba: "AGBA",
        elvt: "ELVT",
        evlv: "EVLV",
        ecln: "ECLN",
        obtr: "OBTR",
        sycg: "SYCG",
        elvl: "ELVL",
        fits: "FITS",
        lmme: "LMME",
        pink: "PINK",
        lmlt: "LMLT",
        r3: "R3",
        gopr: "GOPR",
        lnst: "LNST",
        tgts: "TGJT",
        krft: "KRFT",
        swtr: "SWTR",
        bcd: "BCD",
        shyd: "SHYD",
    },
};

export default domainsAndTenants;
